import { useSelector } from 'react-redux';
import { CreateNumberTrackerMutationVariables, CreateNumberTrackerInput } from '../../../graphql';
import { voucherSettingType } from '../types';
import { CreateNumberTrackerMutationFN } from './createFinancialyear.api';

export const createNumberTrackerSettings = async (input: voucherSettingType): Promise<void> => {
  const financialyearid: number = Number(input.financialyearid);
  const companyid: number = Number(input.companyid);
  const regType: number = Number(input.regType);
  const commonFields: Omit<CreateNumberTrackerInput, 'entrytypecd' | 'serialnumber' | 'serialflag' | 'prefix'> = {
    serialisactive: 1,
    startinvoicenumber: 1,
    serialisused: 0,
    nextinvoicenumber: 1,
    suffix: '',
    financialyearid,
    companyid,
  };

  const inputArray: CreateNumberTrackerInput[] = [
    {
      ...commonFields,
      entrytypecd: 'SalesInvoice',
      serialnumber: 'SINV',
      serialflag: 2,
      prefix: 'SINV',
    },
    {
      ...commonFields,
      entrytypecd: 'SalesInvoice',
      serialnumber: 'BOS',
      serialflag: 1,
      prefix: 'BOS',
    },
    {
      ...commonFields,
      entrytypecd: 'PosInvoice',
      serialnumber: 'POS',
      serialflag: 2,
      prefix: 'POS',
    },
    {
      ...commonFields,
      entrytypecd: 'PosInvoice',
      serialnumber: 'PBOS',
      serialflag: 1,
      prefix: 'PBOS',
    },
    {
      ...commonFields,
      entrytypecd: 'PurchaseInvoice',
      serialnumber: 'PINV',
      serialflag: 2,
      prefix: 'PINV',
    },
    {
      ...commonFields,
      entrytypecd: 'Payment',
      serialnumber: 'PMT',
      serialflag: 2,
      prefix: 'PMT',
    },
    {
      ...commonFields,
      entrytypecd: 'Receipt',
      serialnumber: 'RPT',
      serialflag: 2,
      prefix: 'RPT',
    },
    {
      ...commonFields,
      entrytypecd: 'Journal',
      serialnumber: 'JV',
      serialflag: 2,
      prefix: 'JV',
    },
    {
      ...commonFields,
      entrytypecd: 'CreditInvoice',
      serialnumber: 'CDN',
      serialflag: 2,
      prefix: 'CDN',
    },
    {
      ...commonFields,
      entrytypecd: 'DebitInvoice',
      serialnumber: 'DBN',
      serialflag: 2,
      prefix: 'DBN',
    },
  ];

  const finalArray =
    regType === 1 || regType === 3 ? inputArray.filter((o) => o.serialnumber !== 'SINV' && o.serialnumber !== 'POS') : inputArray;

  for (const inputItem of finalArray) {
    const payload: CreateNumberTrackerMutationVariables = {
      createNumberTrackerInput: [inputItem],
    };

    try {
      await CreateNumberTrackerMutationFN(payload);
    } catch (error: unknown) {
      throw error;
    }
  }
};
